import { initialState, CountriesState } from './selectors';
import * as actions from './actions';

export default (
  state: CountriesState = initialState,
  action: actions.CountriesAction,
) => {
  switch (action.type) {
    case actions.COUNTRIES_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.COUNTRIES_ACTIONS.SUCCEEDED: {
      const { payload } = action as actions.CountriesSucceeded;
      return { ...state, loading: false, countries: payload.countries };
    }

    case actions.COUNTRIES_ACTIONS.FAILED: {
      const { error } = action as actions.CountriesFailed;
      return { ...state, error, loading: false };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Countries/services/reducer.ts